import * as React from "react";
import { styled } from "@mui/material/styles";
import { isDefinedAndTrue, toTitleCase } from "../common/services/Utilities";
import { Typography, TypographyProps } from "@mui/material";
import { selectedStatesAlpha } from "../refdata/FilterOptions";

const PREFIX = "AddressDisplay";

const classes = {
  boldAddress: `${PREFIX}-boldAddress`,
};

const Root = styled("div")(({ theme }) => ({
  [`& .${classes.boldAddress}`]: {
    "& p": {
      fontWeight: "bold",
    },
  },
}));

export interface Address {
  address: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
}

export interface Props {
  addressObject: Address;
  wrapAddress?: boolean;
  align?: TypographyProps["align"];
  bold?: boolean;
  useFullStateName?: boolean;
}

export default function AddressDisplay({
  addressObject,
  wrapAddress,
  align,
  bold,
  useFullStateName,
}: Props) {
  const addressProps: TypographyProps = {
    noWrap: !wrapAddress,
    color: bold ? "blue" : "primary",
    align: align ? align : "center",
  };
  return (
    <Root className={bold ? classes.boldAddress : undefined}>
      {addressObject.address ? (
        // The split here is to avoid having an extra <p> tag in the html
        // This following code after also only splits the line between the last comma because of special cases referring to Suites
        addressObject.address.split(",").length > 1 ? (
          <>
            <Typography {...addressProps} id="main-address-line">
              {toTitleCase(
                addressObject.address.substring(
                  0,
                  addressObject.address.lastIndexOf(","),
                ),
              )}
            </Typography>
            <Typography {...addressProps} id="sub-address-line">
              {toTitleCase(
                addressObject.address.substring(
                  addressObject.address.lastIndexOf(",") + 1,
                  addressObject.address.length,
                ),
              )}
            </Typography>
          </>
        ) : (
          <>
            <Typography {...addressProps} id="main-address-line">
              {toTitleCase(addressObject.address)}
            </Typography>
            {isDefinedAndTrue(addressObject.address2) ? (
              <Typography {...addressProps} id="main-address-line2">
                {` ${toTitleCase(addressObject.address2)} `}
              </Typography>
            ) : (
              ""
            )}
          </>
        )
      ) : (
        ""
      )}
      <Typography {...addressProps} id="last-address-line">
        {`${addressObject.city ? `${toTitleCase(addressObject.city)}, ` : ""}${
          addressObject.state
            ? `${useFullStateName ? selectedStatesAlpha.find((st) => st.value === addressObject.state)?.label : addressObject.state}`
            : ""
        } ${addressObject.zip ? addressObject.zip : ""}`.replace(
          /(^[,\s]+)|([,\s]+$)/g,
          "",
        )}
      </Typography>
    </Root>
  );
}
